import type { FormlyExtension, FormlyFieldConfig, FormlyFieldProps } from "@ngx-formly/core";

export class FormlyClassNameExtension implements FormlyExtension {
  prePopulate(field: FormlyFieldConfig<FormlyFieldProps & Record<string, any>>): void {
    field.expressions ??= {};
    field.props ??= {};

    if (field.props.editClassName && !field.expressions.className) {
      field.expressions.className = (field): string =>
        field.props.readonly ? field.props.className : field.props.editClassName;
    }

    if (field.props.editFieldGroupClassName && !field.expressions.fieldGroupClassName) {
      field.expressions.fieldGroupClassName = (field): string =>
        field.props.readonly ? field.props.fieldGroupClassName : field.props.editFieldGroupClassName;
    }
  }
}
